module.exports = __webpack_public_path__ + "static/media/up.1ab410e0.webp";